import React from 'react';
import { Tooltip } from 'antd';

export default [
  {
    title: 'Student Name',
    dataIndex: 'studentName',
    key: 'studentName',
    sorter: true
  },
  {
    title: 'Instructor',
    dataIndex: 'instructor',
    key: 'instructor',
    sorter: true
  },
  {
    title: 'Archiver/Deleter',
    dataIndex: 'deleter',
    key: 'deleter',
    sorter: false
  },
  {
    title: 'Note',
    dataIndex: 'note',
    key: 'note',
    sorter: true
  },
  {
    title: 'Test type',
    dataIndex: 'testType',
    key: 'testType',
    sorter: true
  },
  {
    title: 'Program type',
    dataIndex: 'programType',
    key: 'programType',
    sorter: false
  },
  {
    title: 'Attendance archived date',
    dataIndex: 'attendanceArchivedDate',
    key: 'attendanceArchivedDate',
    sorter: true,
    render: value => {
      return (
        <Tooltip title="The date displayed here is based on the timezone of the branch.">
          <span>{value}</span>
        </Tooltip>
      );
    }
  },
  {
    title: 'Test archived date',
    dataIndex: 'testArchivedDate',
    key: 'testArchivedDate',
    sorter: true,
    render: value => {
      return (
        <Tooltip title="The date displayed here is based on the timezone of the branch.">
          <span>{value}</span>
        </Tooltip>
      );
    }
  },
  {
    title: 'Attendance deleted date',
    dataIndex: 'attendanceDeletedDate',
    key: 'attendanceDeletedDate',
    sorter: false,
    render: value => {
      return (
        <Tooltip title="The date displayed here is based on the timezone of the branch.">
          <span>{value}</span>
        </Tooltip>
      );
    }
  },
  {
    title: 'Test deleted date',
    dataIndex: 'testDeletedDate',
    key: 'testDeletedDate',
    sorter: false,
    render: value => {
      return (
        <Tooltip title="The date displayed here is based on the timezone of the branch.">
          <span>{value}</span>
        </Tooltip>
      );
    }
  }
];
